import { useState, useEffect, useRef, useCallback } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../components/helpers";
import api from "../../service/api";
import { BaseTable } from "../../components/table";
import MeterColumns from "../../components/columns/user";
import { toast } from "react-toastify";
import { Tables } from "../../components/styles";
import styled from "styled-components";
import tables from "../../components/styles/table";

const Users = ({ show }: { show: boolean }) => {
  localStorage.setItem("currentPath", "/admin/meters");
  const [selectedUserStatus, setSelectedUserStatus] = useState<"active" | "inactive" | null>(null);
  const [actionLoading, setActionLoading] = useState(false); // New loading state for actions
const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

  type User = {
    id: string;
    status: "active" | "inactive";
    // add other properties as needed
  };
  
  const [userData, setUserData] = useState<User[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState("");
  const [showActionModal, setShowActionModal] = useState(false);
  const navigate = useNavigate();
  const mounted = useRef(false);
  const token = localStorage.getItem("token");



  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.req("/admin/all", undefined, null, token);
      if (data?.data?.badToken) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/su/admin/login");
      }
      if (data?.status === "success") {
        setUserData(data?.data?.details);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  }, [navigate, token]);

  useEffect(() => {
    mounted.current = true;
    fetchUsers();
    return () => {
      mounted.current = false;
    };
  }, [fetchUsers]);

  const handleIconClick = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    const iconElement = target.closest(".action-icon") as HTMLElement;

    if (iconElement && iconElement.classList.contains("action-icon")) {
      const id = iconElement.getAttribute("data-id");
      if (id) {
        const selectedUser = userData.find((user) => user.id === id);
        setSelectedRowId(id);
        setSelectedUserStatus(selectedUser?.status ?? null);
        setShowActionModal(true);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleIconClick);
    return () => document.removeEventListener("click", handleIconClick);
  }, [userData]);

  const handleEdit = (id: string | null) => {
    console.log("Edit", id);
    setShowActionModal(false);
  };

  const handleActivate = async (id: string | null) => {
    if (!id) return;
    
    setActionLoading(true);
    try {
      const currentStatus = selectedUserStatus;
      const statusData = {
        status: currentStatus === "active" ? "suspended" : "active",
      };

      const response = await api.req(
        `/admin/status/${id}`,
        "PATCH",
        statusData,
        token
      );
      if (response?.status === "success") {
        toast.success(
          `User ${currentStatus === "active" ? "deactivated" : "activated"} successfully`
        );
        // Refresh the user list
        await fetchUsers();
      } else {
        toast.error(response?.data?.message || "Operation failed");
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong!");
    } finally {
      setActionLoading(false);
      setShowActionModal(false);
    }
  };


   const handleDelete = async (id: string | null) => {
setActionLoading(true);
    try {
      if (!token || !selectedRowId) {
        toast.error("Missing required information for delete operation.");
        return;
      }
      const response = await api.req(`/admin/delete/${selectedRowId}`, "DELETE", null, token);
      if (response?.status === 'success') {
  
        toast.success(response.data.data.message);
        await fetchUsers();
      }
    } catch (error:any) {
      console.log(error.response.data.message);
      toast.error(error.response.data.message || "something went wrong!")
    }
    finally {
      setActionLoading(false);
      setShowActionModal(false);
    }
  };

  return (
    <div
      className={`flex flex-col w-full pt-8 transition-all duration-300 ease-in-out ${
        show ? "md:ml-[18rem]" : "md:ml-[10rem]"
      }`}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Users</title>
      </Helmet>

      {loading ? (
        <div className="flex justify-center items-center h-[70vh]">
          <Spinner />
        </div>
      ) : (
        <div className="ml-4">
          <div className="pt-4">
            <h2 className="uppercase text-[#cd5c08] font-semibold text-xl">
              Users
            </h2>
          </div>

          {/* <div className="flex flex-col w-full md:w-4/5 mt-12 mb-4">
            <div className="flex flex-col bg-white p-4 md:p-12 border border-gray-300 rounded-lg">
              <BaseTable data={userData} columns={MeterColumns} />
            </div>
            
          </div> */}
            <DatatableContainer>
            <TableContainer>
                <BaseTable data={userData} columns={MeterColumns} />
            </TableContainer>
        </DatatableContainer>

          {showActionModal && (
            <div
              className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[100]"
              onClick={() => !actionLoading && setShowActionModal(false)}
            >
              <div
                className="bg-white p-8 rounded-lg w-[300px] relative"
                onClick={(e) => e.stopPropagation()}
              >
                {actionLoading && (
                  <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center rounded-lg">
                    <Spinner />
                  </div>
                )}
                
                <h4 className="text-lg font-medium mb-4">Choose Action</h4>
                <button
                  className="w-full my-2 py-2 bg-[#cd5c08] text-white rounded-md hover:bg-[#b45307] transition-colors disabled:opacity-50"
                  onClick={() => handleEdit(selectedRowId)}
                  disabled={actionLoading}
                >
                  Edit
                </button>
              <button
  className="w-full my-2 py-2 bg-[#cd5c08] text-white rounded-md hover:bg-[#b45307] transition-colors disabled:opacity-50"
  onClick={() => {
    setShowDeleteConfirmModal(true); // Instead of calling handleDelete directly
  }}
  disabled={actionLoading}
>
  Delete
</button>
                <button
                  className="w-full my-2 py-2 bg-[#cd5c08] text-white rounded-md hover:bg-[#b45307] transition-colors disabled:opacity-50"
                  onClick={() => handleActivate(selectedRowId)}
                  disabled={actionLoading}
                >
                  {selectedUserStatus === "active" ? "Deactivate" : "Activate"}
                </button>
                <button
                  className="w-full my-2 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition-colors disabled:opacity-50"
                  onClick={() => setShowActionModal(false)}
                  disabled={actionLoading}
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {showDeleteConfirmModal && (
  <div
    className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-[110]"
    onClick={() => !actionLoading && setShowDeleteConfirmModal(false)}
  >
    <div
      className="bg-white p-6 rounded-lg w-[300px] relative"
      onClick={(e) => e.stopPropagation()}
    >
      {actionLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-70 flex items-center justify-center rounded-lg">
          <Spinner />
        </div>
      )}
      <h4 className="text-lg font-medium mb-4 text-center text-red-600">
        Confirm Delete
      </h4>
      <p className="text-center text-gray-600 mb-6">
        Are you sure you want to delete this user?
      </p>
      <div className="flex gap-4 justify-between">
        <button
          className="flex-1 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500 transition-colors disabled:opacity-50"
          onClick={() => setShowDeleteConfirmModal(false)}
          disabled={actionLoading}
        >
          Cancel
        </button>
        <button
          className="flex-1 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50"
          onClick={() => {
            handleDelete(selectedRowId);
            setShowDeleteConfirmModal(false);
          }}
          disabled={actionLoading}
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};
const DatatableContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 80%;
  margin-bottom: 1rem;
  margin-top: 3rem;
  ${Tables.datatable};
  ${tables.buttons};
`;

const TableContainer = styled.div`
  position: relative;
  display: flex;
  margin: 10px 0px 20px 0px;
  flex-direction: column;
  border: 1px solid #ccc;
  transition: all 0.25s cubic-bezier(0.3, 0.3, 0.3, 0.3);

  border-radius: 10px;
  background-color: #fff;
  padding: 50px;

  &:hover {
    /* box-shadow: ${({ theme }) => theme.hover}; */
  }
`;
export default Users;